import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Button, IconChevron } from "braid-design-system";
import { useContext } from "react";
import { TrackingContext } from "../../../../elements/Expectations/RelevantApplications/RelevantApplications.mjs";
import { compareAllFeaturesButton } from "./CompareAllFeaturesButton.css.mjs";
const CompareAllFeaturesButton = ({
  isExpanded,
  onClick
}) => {
  const { trackEvent } = useContext(TrackingContext);
  const onButtonClick = (event) => {
    if (onClick) {
      onClick(event);
    }
    trackEvent({
      type: "compare",
      // if expanded, button on click is to close
      action: isExpanded ? "closed" : "opened"
    });
  };
  return /* @__PURE__ */ jsx(Box, { className: compareAllFeaturesButton, children: /* @__PURE__ */ jsxs(
    Button,
    {
      onClick: onButtonClick,
      tone: "brandAccent",
      size: "small",
      "aria-expanded": isExpanded,
      iconPosition: "trailing",
      icon: /* @__PURE__ */ jsx(IconChevron, { direction: isExpanded ? "up" : "down" }),
      children: [
        isExpanded ? "Hide" : "Compare",
        " all features"
      ]
    }
  ) });
};
export {
  CompareAllFeaturesButton
};
